import React, { FC } from 'react';

// tslint:disable-next-line: max-line-length
import SummaryTableHeadRow from '../../../../../../../components/RoundScoreSummary/Components/RoundScoreSummaryMainTable/Components/SummaryTable/Components/SummaryTableHeadRow';
import { holesList } from '../../../../../../../Utils/holesList';
// tslint:disable-next-line: max-line-length
import SummaryTableRow from '../../../../../../../components/RoundScoreSummary/Components/RoundScoreSummaryMainTable/Components/SummaryTable/Components/SummaryTableRow';
import { getClasses } from '../../../../../../../Utils/getClasses';
import { getAppliedHandicap } from '../../../../../../../Utils/getAppliedHandicap';
import { IGroupHoleResults } from '../GroupScorecards';
import { StyledGroupScorecardsSummaryTable } from './GroupScorecardsSummaryTable.styles';

interface IProps {
  groupHoleResults: IGroupHoleResults[];
  pars: string[];
  start: number;
  end: number;
}

export const GroupScorecardsSummaryTable: FC<IProps> = props => {
  const { groupHoleResults, pars, start, end } = props;

  return (
    <StyledGroupScorecardsSummaryTable>
      <colgroup>
        {new Array(end - start + 1).fill('empty').map((_, index) => (
          <col key={index} />
        ))}
      </colgroup>

      <thead>
        <SummaryTableHeadRow title="HOLE" values={holesList.slice(start, end).map(String)} />

        <SummaryTableHeadRow title="PAR" values={pars.slice(start, end)} />
      </thead>

      <tbody>
        {groupHoleResults.map(groupHoleResult => (
          <>
            <tr>
              <td colSpan={10}>
                <p>{groupHoleResult.playerName}</p>
              </td>
            </tr>

            <SummaryTableRow
              key={`SummaryTableRow-${groupHoleResult.playerName}`}
              title={'GRS'}
              values={groupHoleResult.holeGrossResults.slice(start, end).map(String)}
              getCellClassName={(h, index) =>
                `value-wrapper ${getClasses(pars, index, h[0], false) +
                  ' ' +
                  getAppliedHandicap(h[1])}`
              }
            />
          </>
        ))}
      </tbody>
    </StyledGroupScorecardsSummaryTable>
  );
};
